import http from '../utils/http';
import { UserInfo } from 'src/auth/types';

interface RefreshTokenResponse {
  success: boolean;
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  user: UserInfo;
}

export const refreshMagicToken = async (
  refreshToken: string,
): Promise<RefreshTokenResponse> => {
  const response = await http<RefreshTokenResponse>(
    '/shared/auth/magic-link/refresh-token',
    {
      method: 'POST',
      body: { refreshToken },
    },
  );

  if (response.status === 200 && response.data) {
    return response.data;
  }

  throw new Error('Failed to refresh magic link token');
};

export default refreshMagicToken;
